import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { SalesDashboardService } from '../services/sales-dashboard.service';


@Component({
  selector: 'app-modal-image-view',
  templateUrl: './modal-image-view.component.html',
  styleUrls: ['./modal-image-view.component.scss']
})
export class ModalImageViewComponent implements OnInit {
  imgName: string;
  imgUrl: string;
  imgNotes: string;

  constructor(
    public dialogRef: MatDialogRef<ModalImageViewComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private salesDashboardService: SalesDashboardService
  ) {
    this.salesDashboardService.openImg.subscribe(value => {
      this.imgName = value.imgName;
      this.imgUrl = value.imgUrl;
      this.imgNotes = value.imgNotes;
    })
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modal-image-view/modal-image-view.component.ts